import { render, staticRenderFns } from "./AbkPageNotFound.vue?vue&type=template&id=efcd7492&scoped=true&"
import script from "./AbkPageNotFound.vue?vue&type=script&lang=js&"
export * from "./AbkPageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./AbkPageNotFound.vue?vue&type=style&index=0&id=efcd7492&scoped=true&lang=scss&"
import style1 from "./AbkPageNotFound.vue?vue&type=style&index=1&id=efcd7492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcd7492",
  null
  
)

export default component.exports